module.exports = __webpack_public_path__ + "img/tamamliyocom.4ea7a046.png";